import myAxios from "@/plugins/axios";

const ORDER = "/order"

const orderService = {

    getOrdersReport(params) {
        let queryParams = Object.keys(params).filter(key => key !== "campaignId" && params[key] !== null).map(key => key + '=' + params[key]).join('&');

        let reportsUrl = `${ORDER}/report`

        let apiUrl = queryParams ? `${reportsUrl}?${queryParams}` : reportsUrl

        return myAxios.privateInstance
            .get(apiUrl).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },

    verify(params) {

        return myAxios.privateInstance
            .post(`${ORDER}/${params.orderId}/${params.verified ? 'true' : 'false'}`, null).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error || "Error verifying order");
            });
    },

    updateOrder(params) {

        return myAxios.privateInstance
            .put(`${ORDER}/${params.orderId}`, params).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error || "Error updating order");
            });
    },
}

export default orderService